// extracted by mini-css-extract-plugin
export default {"Container":"canvasGate_Container__2cwt1","HelpBar":"canvasGate_HelpBar__vhL5D","FloatingLabel":"canvasGate_FloatingLabel__ZzXm5","HiddenWidget":"canvasGate_HiddenWidget__dWsN1"};